import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ViewUIPlus from 'view-ui-plus'
import '@/theme/index.less'
import 'remixicon/fonts/remixicon.css'
import App from './App.vue'
import router from './router'
import { config } from 'md-editor-v3'
import mermaid from 'mermaid'
import { initXsrfToken } from '@/utils/http'

// 配置 mermaid
mermaid.initialize({
  startOnLoad: false,
  theme: 'dark'
})

// 将 mermaid 挂载到 window，确保 md-editor-v3 能找到它
if (typeof window !== 'undefined') {
  (window as any).mermaid = mermaid
}

config({
  markdownItConfig() {
    // 可以在这里配置 markdown-it 插件
  },
  mermaidConfig(c) {
    return {
      ...c,
      theme: 'dark',
      securityLevel: 'loose',
      fontFamily: 'inherit'
    }
  }
})

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(ViewUIPlus, {
  transfer: true,
  select: {
    transfer: true
  },
  datePicker: {
    transfer: true
  },
  timePicker: {
    transfer: true
  },
  cascader: {
    transfer: true
  },
  colorPicker: {
    transfer: true
  },
  poptip: {
    transfer: true
  },
  tooltip: {
    transfer: true
  }
} as any)

// 初始化 XSRF Token（在应用启动时）
initXsrfToken().then(() => {
  console.log('[App] XSRF Token initialized')
}).catch(err => {
  console.warn('[App] Failed to initialize XSRF Token:', err)
})

app.mount('#app')